import * as React from "react";
function SvgWifi(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2.248 8.23v.001a.928.928 0 001.307.046 12.777 12.777 0 018.746-3.428c3.269 0 6.374 1.218 8.745 3.428a.926.926 0 001.307-.046h.001a.927.927 0 00-.047-1.307A14.622 14.622 0 0012.3 3 14.627 14.627 0 002.294 6.923a.926.926 0 00-.046 1.308zm10.053-3.68a13.077 13.077 0 010 0zM12.3 8.586c2.427 0 4.705.942 6.417 2.652a.919.919 0 00.654.272c.246 0 .48-.096.654-.271a.919.919 0 00.271-.654.919.919 0 00-.27-.654A10.854 10.854 0 0012.3 6.737c-2.92 0-5.665 1.135-7.725 3.195a.92.92 0 000 1.308.92.92 0 001.308 0A9.014 9.014 0 0112.3 8.587zm0-.3a9.314 9.314 0 00-6.63 2.741.62.62 0 01-.883 0 .626.626 0 01.883 0 9.315 9.315 0 016.63-2.74zm-.003 3.748c1.505 0 2.918.584 3.978 1.644a.624.624 0 100 0 5.588 5.588 0 00-3.978-1.644 5.59 5.59 0 00-3.977 1.644l.212.213a.92.92 0 01-1.308-.001.92.92 0 010-1.308l.213.213-.213-.213a7.127 7.127 0 015.073-2.097 7.13 7.13 0 015.074 2.098.92.92 0 01-.001 1.308.924.924 0 01-1.307 0 5.288 5.288 0 00-3.766-1.557 5.29 5.29 0 00-3.765 1.556l-.212-.212a5.59 5.59 0 013.977-1.644zm5.044 1.171l.001.032m-8.467 4.42a3.429 3.429 0 003.425 3.424 3.429 3.429 0 003.425-3.425 3.429 3.429 0 00-3.425-3.425 3.429 3.429 0 00-3.425 3.425z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgWifi);
export default ForwardRef;
